import { pick, assign } from 'lodash';
import { fetchListingPricing } from '../../../app-main/actions/listingPricing';

const onChangeFnbPriceForm = (values, dispatch) => {
  const { prices = {}, fandb = {} } = values;

  if (fandb.fandb_required) {
    // For FNB pricing, we need to get the pricing payload by going through the pricing calc first
    const value = prices.base_value; // need to convert base_value to value
    const payload = assign({}, { value }, pick(prices, ['currency', 'tax_percent', 'display_gratuity_percent']));
    const calcQueryString = Object.keys(payload).map(key => `${key}=${payload[key]}`).join('&');

    return dispatch(fetchListingPricing(`calc?${calcQueryString}`));
  }
};

export default onChangeFnbPriceForm;
